import { EventNameFormFields, FormState, TemplateFormFields } from "./types"

export const EMPTY_TEMPLATES: TemplateFormFields = {
  activationEmail: "",
  passwordReset: "",
  kycRejected: "",
  withdrawalSuccessful: "",
  passwordChanged: "",
  kycApproved: "",
  kycRequest: "",
  selfExclusionConfirm: "",
  selfExclusionSetDuration: "",
  selfExclusionEnded: "",
  adminMessage: ""
}

export const EMPTY_EVENT_NAMES: EventNameFormFields = {
  depositSuccess: "",
  withdraw: "",
  depositFailed: "",
  withdrawalRequested: "",
  birthdayToday: "",
  activationEmail: "",
  passwordResetRequested: "",
  passwordChanged: "",
  kycApproved: "",
  kycRejected: "",
  withdrawalSuccessful: ""
}

/**
 * Display order for the templates grid, and the single list the grid renders from.
 *
 * A Record keyed by the field union, so adding a template to `CioTransactionalTemplates`
 * fails the build until it is given a position here — an unlisted field is not just
 * unlabelled, it never reaches the form, so the operator cannot configure it at all.
 * Labels come from `settings.customerio.templates.fields.*`.
 */
const TEMPLATE_FIELD_ORDER: Record<keyof TemplateFormFields, true> = {
  activationEmail: true,
  passwordReset: true,
  kycRejected: true,
  kycApproved: true,
  kycRequest: true,
  passwordChanged: true,
  withdrawalSuccessful: true,
  selfExclusionConfirm: true,
  selfExclusionSetDuration: true,
  selfExclusionEnded: true,
  adminMessage: true
}

export const TEMPLATE_FIELDS = Object.keys(TEMPLATE_FIELD_ORDER) as (keyof TemplateFormFields)[]

/** Display order for the event-names grid. Exhaustive, like `TEMPLATE_FIELD_ORDER`. */
const EVENT_NAME_FIELD_ORDER: Record<keyof EventNameFormFields, true> = {
  depositSuccess: true,
  depositFailed: true,
  withdraw: true,
  withdrawalRequested: true,
  withdrawalSuccessful: true,
  birthdayToday: true,
  activationEmail: true,
  passwordResetRequested: true,
  passwordChanged: true,
  kycApproved: true,
  kycRejected: true
}

export const EVENT_NAME_FIELDS = Object.keys(EVENT_NAME_FIELD_ORDER) as (keyof EventNameFormFields)[]

export const INITIAL_FORM: FormState = {
  enabled: false,
  siteId: "",
  apiKey: "",
  appApiKey: "",
  region: "EU",
  amountFormat: "formatted",
  transactionalTemplates: EMPTY_TEMPLATES,
  eventNames: EMPTY_EVENT_NAMES
}
